// export const webEndPoint = "https://gjjewellery.in/dev_api/api/";
export const webEndPoint = "https://gjjewellery.in/test_api/api/";